import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
// react-router-dom components
import { Link } from "react-router-dom";
// @mui material components
import {
  FormControl,
  FormControlLabel,
  FormHelperText,
  IconButton,
  InputAdornment,
  Radio,
  RadioGroup,
} from "@mui/material";
// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";

// third party
import { Formik } from "formik";

// Images & icon
import { CheckCircle, Warning } from "@mui/icons-material";
import MDatepicker from "components/MDatepicker";
import MDRadioButton from "components/MDRadioButton";
import PhoneInput from "react-phone-input-2";

const CompleteInfoForm = (props) => {
  const { t } = useTranslation();
  const btns = [
    { label: "زن", value: "female", select: true },
    { label: "مرد", value: "man", select: false },
  ];
  const [data, setData] = useState(btns);
  useEffect(() => {
    let element = document.querySelector(".special-label");
    element.innerHTML = t("labels.phone");
  }, []);
  return (
    <Formik
      initialValues={{
        phone: "0902232435",
      }}
      onSubmit={async (values, { setErrors, setStatus, setSubmitting }) => {
        try {
        } catch (err) {
          console.error(err);
        }
      }}
    >
      {({ errors, handleBlur, handleChange, handleSubmit, isSubmitting, touched, values }) => (
        <MDBox component="form" role="form">
          <FormControl fullWidth error={Boolean(touched.phone && errors.phone)} sx={{ mb: 2 }}>
            <MDTypography fontSize="xs" pb={1} pl={0.5}>
              {t("labels.phone")}
            </MDTypography>
            <PhoneInput
              inputProps={{
                name: "phone",
                label: t("labels.phone"),
              }}
              country={"ir"}
            />
            {touched.phone && errors.phone && (
              <FormHelperText error id="standard-weight-helper-text-phone-login">
                {errors.phone}
              </FormHelperText>
            )}
          </FormControl>
          <MDInput
            formSx={{ mb: 2 }}
            fullWidth
            formError={touched.name && errors.name}
            label={t("labels.name")}
            size="small"
            id="outlined-adornment-name-login"
            type="name"
            value={values.name}
            name="name"
            onBlur={handleBlur}
            onChange={handleChange}
            error={errors.name}
          />
          <MDInput
            formError={touched.family && errors.family}
            formSx={{ mb: 2 }}
            error={errors.family}
            size="small"
            id="outlined-adornment-family-login"
            type="family"
            value={values.family}
            name="family"
            onBlur={handleBlur}
            onChange={handleChange}
            label={t("labels.family")}
          />

          <MDBox mb={2}>
            <MDatepicker label={t("labels.birthDate")} />
          </MDBox>
          <MDBox
            mb={2}
            sx={({ breakpoints }) => ({
              [breakpoints.down("xl")]: {
                display: "flex",
                alignItems: "center",
              },
            })}
          >
            <MDTypography fontSize="xs" pb={0} pl={0.5} pr={1}>
              {t("labels.gender")}
            </MDTypography>
            <RadioGroup
              row
              aria-labelledby="demo-row-radio-buttons-group-label"
              name="row-radio-buttons-group"
            >
              <FormControlLabel value="female" control={<Radio />} label="زن" />
              <FormControlLabel value="male" control={<Radio />} label="مرد" />
            </RadioGroup>
          </MDBox>
        </MDBox>
      )}
    </Formik>
  );
};
export default CompleteInfoForm;
